import { Pipe, PipeTransform } from '@angular/core';

import { StringUtils } from 'tiime-expert-utils';

import { PcgEntry } from '@models/pcg-entry';

@Pipe({
  name: 'pcgEntriesWithoutArchived',
  standalone: true
})
export class PcgEntriesWithoutArchivedPipe implements PipeTransform {
  transform(pcgEntries: PcgEntry[], exceptPcgEntryId?: number, exceptFilter?: string): PcgEntry[] {
    if (!pcgEntries?.length) {
      return [];
    }

    return pcgEntries.filter(
      (pcgEntry: PcgEntry) =>
        this.withoutArchivedCondition(pcgEntry) ||
        this.exceptPcgEntryIdCondition(pcgEntry, exceptPcgEntryId) ||
        this.exceptFilterCondition(pcgEntry, exceptFilter)
    );
  }

  private withoutArchivedCondition(pcgEntry: PcgEntry): boolean {
    return !pcgEntry.archived;
  }

  private exceptPcgEntryIdCondition(pcgEntry: PcgEntry, pcgEntryId: number): boolean {
    if (!pcgEntryId) {
      return false;
    }

    return pcgEntry.id === pcgEntryId;
  }

  private exceptFilterCondition(pcgEntry: PcgEntry, filter: string): boolean {
    if (!filter) {
      return false;
    }

    const charLimit = 3;

    const accountNumberCondition =
      pcgEntry.accountNumber?.length >= charLimit && filter.length >= charLimit
        ? StringUtils.normalizeToLowerCase(pcgEntry.accountNumber).includes(StringUtils.normalizeToLowerCase(filter))
        : StringUtils.normalizeToLowerCase(pcgEntry.accountNumber) === StringUtils.normalizeToLowerCase(filter);

    const labelCondition =
      pcgEntry.label?.length >= charLimit && filter.length >= charLimit
        ? StringUtils.normalizeToLowerCase(pcgEntry.label).includes(StringUtils.normalizeToLowerCase(filter))
        : StringUtils.normalizeToLowerCase(pcgEntry.label) === StringUtils.normalizeToLowerCase(filter);

    return accountNumberCondition || labelCondition;
  }
}
